<template>
  <div id="Index">
    <jw-frame>
        <Form ref="infoForm" :model="introduction" :rules="ruleValidate" label-position="left" :label-width="85" :label-colon="true">
          <FormItem label="协会简介" prop="content">
            <Input type="textarea" :rows="18" v-model="introduction.content" placeholder="请输入协会简介"/>
          </FormItem>
        </Form>
        <div style="text-align: right;">
          <Button type="primary" @click="saveAction">保 存</Button>
        </div>
    </jw-frame>
  </div>
</template>

<script>
import JwMenu from "@/components/JwMenu.vue";
import {getIntroduction, editIntroduction} from "@/request/association";

export default {
  name: "Index",
  components: {
    JwMenu
  },
  data() {
    return {
      introduction: {
        content: ''
      },
      ruleValidate: {
        content: [
          {required: true, message: '请输入协会简介', trigger: 'blur'}
        ],
      }
    }
  },
  created() {
    this.onGetIntroduction()
  },
  methods: {
    saveAction() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          editIntroduction(this.introduction).then(res=> {
            let { error, message } = res.data
            if (error === 200) {
              this.$Notice.success({
                title: '成功提示',
                desc: message
              })
              this.onGetWebSitInfo();
            }else {
              this.$Notice.error({
                title: '错误提示',
                desc: message
              })
            }
          })
        }
      })
    },
    onGetIntroduction() {
      getIntroduction().then(res=> {
        this.introduction = res.data.data.introduction
      })
    }
  }
}
</script>

<style scoped>

</style>
